var _excluded = ["dictType", "value", "localDict", "level", "childrenLoadLevel", "delimiter", "addonAfter", "render", "placeholder", "url"],
  _excluded2 = ["dictType", "value", "localDict", "level", "childrenLoadLevel", "delimiter", "addonAfter", "placeholder", "multiple"],
  _excluded3 = ["value", "defaultValue", "render", "addonAfter", "prefix"],
  _excluded4 = ["value"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useDict, useDictMap } from "./dict";
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DictText = function DictText(props) {
  var defaultRender = function defaultRender(content, label, value, index) {
    return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({}, rest), {}, {
      children: content !== null && content !== void 0 ? content : /*#__PURE__*/_jsx("span", {
        className: "text-gray-400",
        children: placeholder
      })
    }), index);
  };
  var dictType = props.dictType,
    value = props.value,
    localDict = props.localDict,
    _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level,
    _props$childrenLoadLe = props.childrenLoadLevel,
    childrenLoadLevel = _props$childrenLoadLe === void 0 ? 5 : _props$childrenLoadLe,
    _props$delimiter = props.delimiter,
    delimiter = _props$delimiter === void 0 ? /*#__PURE__*/_jsx("span", {
      className: "px-1",
      children: "/"
    }) : _props$delimiter,
    addonAfter = props.addonAfter,
    _props$render = props.render,
    render = _props$render === void 0 ? defaultRender : _props$render,
    placeholder = props.placeholder,
    url = props.url,
    rest = _objectWithoutProperties(props, _excluded);
  var map = useDictMap(dictType, {
    local: localDict,
    level: level,
    childrenLoadLevel: childrenLoadLevel,
    url: url
  });
  var getDictValue = function getDictValue(v) {
    if (v != null) {
      var _map$v$label, _map$v;
      if (_typeof(v) === 'object') {
        var _ref, _ref2, _map$v$value$label, _map$v$value;
        return (_ref = (_ref2 = (_map$v$value$label = (_map$v$value = map[v.value]) === null || _map$v$value === void 0 ? void 0 : _map$v$value.label) !== null && _map$v$value$label !== void 0 ? _map$v$value$label : v === null || v === void 0 ? void 0 : v.label) !== null && _ref2 !== void 0 ? _ref2 : v === null || v === void 0 ? void 0 : v.value) !== null && _ref !== void 0 ? _ref : String(v);
      }
      return (_map$v$label = (_map$v = map[v]) === null || _map$v === void 0 ? void 0 : _map$v.label) !== null && _map$v$label !== void 0 ? _map$v$label : v;
    }
    return v;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [Array.isArray(value) ? value.map(function (item, idx) {
      return render( /*#__PURE__*/_jsxs(_Fragment, {
        children: [getDictValue(item), idx + 1 < value.length ? delimiter : '']
      }), getDictValue(item), item, idx);
    }) : render(getDictValue(value), getDictValue(value), value, 0), addonAfter]
  });
};
export var DictCascaderText = function DictCascaderText(props) {
  var dictType = props.dictType,
    value = props.value,
    localDict = props.localDict,
    _props$level2 = props.level,
    level = _props$level2 === void 0 ? 1 : _props$level2,
    _props$childrenLoadLe2 = props.childrenLoadLevel,
    childrenLoadLevel = _props$childrenLoadLe2 === void 0 ? 5 : _props$childrenLoadLe2,
    _props$delimiter2 = props.delimiter,
    delimiter = _props$delimiter2 === void 0 ? /*#__PURE__*/_jsx("span", {
      className: "px-1",
      children: "/"
    }) : _props$delimiter2,
    addonAfter = props.addonAfter,
    placeholder = props.placeholder,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    rest = _objectWithoutProperties(props, _excluded2);
  var options = useDict(dictType, {
    local: localDict,
    level: level,
    childrenLoadLevel: childrenLoadLevel
  });
  if (Array.isArray(value) && options) {
    // 处理单选逻辑（value 为 string[] 时兼容）
    var getSingleLabel = function getSingleLabel(singleValue) {
      if (!Array.isArray(singleValue) || !options) return [];
      var currentOptions = options;
      return singleValue.reduce(function (list, current) {
        if (currentOptions) {
          var item = currentOptions.find(function (i) {
            return i.value === current;
          });
          if (item) {
            list.push(item.label || item.value);
            list.push(delimiter);
            currentOptions = item.children;
          } else {
            list.push(current);
            list.push(delimiter);
          }
        }
        return list;
      }, []);
    };

    // 处理多选逻辑（value 为 string[][]）
    var getMultipleLabels = function getMultipleLabels() {
      if (!Array.isArray(value) || !options) return [];
      return value.map(function (singleValue, groupIndex) {
        var labels = getSingleLabel(singleValue);
        if (labels.length > 0) labels.pop(); // 移除最后一个分隔符
        return /*#__PURE__*/_jsxs("span", {
          children: [labels.map(function (label, idx) {
            return /*#__PURE__*/_jsx("span", {
              children: label
            }, idx);
          }), groupIndex < value.length - 1 ? /*#__PURE__*/_jsx("span", {
            className: "mr-2",
            children: ", "
          }) : null]
        }, groupIndex);
      });
    };

    // 渲染逻辑
    var _content = placeholder;
    if (multiple) {
      // 多选模式：处理 string[][] 类型的 value
      var multipleLabels = getMultipleLabels();
      if (multipleLabels.length > 0) {
        _content = multipleLabels;
      }
    } else {
      // 单选模式：兼容 string[] 类型的 value
      if (Array.isArray(value) && value.length > 0 && !Array.isArray(value[0])) {
        var singleLabels = getSingleLabel(value);
        if (singleLabels.length > 0) {
          singleLabels.pop(); // 移除最后一个分隔符
          _content = singleLabels.map(function (label, idx) {
            return /*#__PURE__*/_jsx("span", {
              children: label
            }, idx);
          });
        }
      }
    }
    return /*#__PURE__*/_jsxs("span", _objectSpread(_objectSpread({}, rest), {}, {
      children: [_content, addonAfter]
    }));
  }
  return null;
};
export var Text = function Text(props) {
  var _ref3;
  var value = props.value,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue,
    render = props.render,
    addonAfter = props.addonAfter,
    prefix = props.prefix,
    rest = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/_jsxs("span", _objectSpread(_objectSpread({}, rest), {}, {
    children: [prefix, typeof render === 'function' ? render(value) : (_ref3 = value !== null && value !== void 0 ? value : defaultValue) !== null && _ref3 !== void 0 ? _ref3 : '-', addonAfter]
  }));
};
export var WrapText = function WrapText(props) {
  var value = props.value,
    rest = _objectWithoutProperties(props, _excluded4);
  var values = "".concat(value || '').split(/\n|\r/g);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: values.map(function (line) {
      return /*#__PURE__*/_jsx("p", _objectSpread(_objectSpread({
        className: classNames('text-wrap')
      }, rest), {}, {
        children: line
      }), line);
    })
  });
};